import styled from 'styled-components';

import PrimitiveModal from '../Modal';

type ActionButtonProps = {
  isExpanded: boolean;
};

export const Container = styled.div`
  width: 100%;
  border-radius: 5px;
  border: 2px solid #e6effb;
  font-family: 'Sora', sans-serif;
  transition: height 0.2s ease-out;
  overflow: hidden;

  header {
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-size: 20px;
      color: #101d40;
      font-weight: 600;
      letter-spacing: 0px;

      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;

      @media screen and (max-width: 767px) {
        text-align: center;
      }
    }

    > div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media screen and (min-width: 768px) {
        justify-content: space-between;
        flex-direction: row;
      }

      > div {
        display: flex;
        gap: 16px;

        @media screen and (max-width: 767px) {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  main {
    overflow-x: auto;
    overflow-y: hidden;
  }
`;

export const ActionButton = styled.button<ActionButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  border: 2px solid #e6effb;
  color: #101d40;
  background-color: transparent;

  svg {
    font-size: 18px;
  }

  &.add {
    background-color: #329bfc;
    border: none;
    color: #ffffff;
  }

  &.arrow {
    svg {
      transition: all 0.2s ease-in-out;
      transform: ${({ isExpanded }) =>
        isExpanded ? 'rotate(180deg)' : 'rotate(360deg);'};
    }
  }

  & + button {
    margin-left: -10px;
  }
`;

export const Table = styled.div`
  min-width: max-content;

  hr {
    border: 1px solid #e6effb;
  }
`;

export const TableCell = styled.div`
  font-size: 13px;

  span {
    font-size: 13px;
    color: #a6a6a6;
    display: block;
  }

  &:not(:last-child):not(:first-child) {
    text-align: center;
  }

  &:last-child {
    margin-left: -25px;
  }

  p {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: minmax(250px, 1fr) 100px 100px 161.2px 40px;
  padding: 16px;
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;

  ${TableCell} {
    &:nth-child(1) {
      width: 250px;
      text-align: left;
    }

    &:nth-child(2) {
      width: 100px;
    }

    &:nth-child(3) {
      width: 100px;
    }

    &:nth-child(4) {
      width: 160px;
    }

    &:nth-child(5) {
      width: 50px;
    }
  }
`;

export const TableBody = styled.div`
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #101d40;
`;

export const Modal = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 36px 40px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 10px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const CreateNewProductButtonContainer = styled.div`
  padding: 16px;
  width: 100%;
  border-top: 1px solid #e6effb;

  button span svg {
    margin: 0px 10px 0px 0px;
  }
`;
